import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/56_card_back_porsche/56_card_back_porsche"
 * Contains 1 texture(s)
 */
export class CardsBacks56CardBackPorscheAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/56_card_back_porsche/56_card_back_porsche';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '56_porsche.png'
    ] as const;
}
